(() => {
  const mq = window.matchMedia('(max-width: 720px)');

  const important = (el, prop, value) => {
    if (el) el.style.setProperty(prop, value, 'important');
  };

  const clearImportant = (el, props) => {
    if (!el) return;
    props.forEach(prop => el.style.removeProperty(prop));
  };

  const fitProductSection = (root) => {
    if (!root) return;
    const stage = root.querySelector('[data-product-stage]');
    const gallery = root.querySelector('[data-product-gallery]');
    if (!stage || !gallery) return;

    const media = [...root.querySelectorAll('.pne-product-media[data-media-id]')];
    const active = media.find(m => m.classList.contains('is-active')) || media[0];
    if (!active) return;

    if (!mq.matches) {
      const wrapperProps = ['position','inset','width','height','min-width','min-height','max-width','max-height','margin','padding','transform','clip-path','filter','opacity','display','overflow','aspect-ratio'];
      [stage, gallery, ...media].forEach(el => clearImportant(el, wrapperProps));
      media.forEach(el => {
        el.removeAttribute('data-pne-mobile-portrait');
        const child = el.querySelector('img,video,iframe,model-viewer');
        clearImportant(child, ['position','inset','display','width','height','min-width','min-height','max-width','max-height','margin','padding','transform','object-fit','object-position']);
      });
      return;
    }

    const sectionWidth = Math.round(
      stage.parentElement?.getBoundingClientRect().width ||
      root.getBoundingClientRect().width ||
      window.innerWidth - 20
    );
    const stagePx = Math.max(300, Math.min(sectionWidth, window.innerWidth - 20));

    important(stage, 'width', '100%');
    important(stage, 'height', `${stagePx}px`);
    important(stage, 'min-height', '0');
    important(stage, 'max-height', 'none');
    important(stage, 'aspect-ratio', 'auto');
    important(stage, 'overflow', 'hidden');

    important(gallery, 'position', 'absolute');
    important(gallery, 'inset', '0');
    important(gallery, 'width', '100%');
    important(gallery, 'height', '100%');
    important(gallery, 'transform', 'none');

    media.forEach(el => {
      const isActive = el === active;
      important(el, 'position', 'absolute');
      important(el, 'inset', '0');
      important(el, 'width', '100%');
      important(el, 'height', '100%');
      important(el, 'min-width', '100%');
      important(el, 'min-height', '100%');
      important(el, 'max-width', 'none');
      important(el, 'max-height', 'none');
      important(el, 'margin', '0');
      important(el, 'padding', '0');
      important(el, 'transform', 'none');
      important(el, 'clip-path', 'none');
      important(el, 'filter', 'none');
      important(el, 'opacity', isActive ? '1' : '0');
      important(el, 'overflow', 'hidden');
      important(el, 'display', isActive ? (el.classList.contains('pne-product-image') ? 'block' : 'grid') : 'none');

      const child = el.querySelector('img,video,iframe,model-viewer');
      if (!child) return;

      const applyChild = () => {
        let portrait = el.classList.contains('pne-product-image--tall-portrait');
        if (child.tagName === 'IMG' && child.naturalWidth && child.naturalHeight) {
          portrait = (child.naturalWidth / child.naturalHeight) < 0.78;
        }
        if (portrait) el.setAttribute('data-pne-mobile-portrait', 'true');
        else el.removeAttribute('data-pne-mobile-portrait');

        important(child, 'position', 'absolute');
        important(child, 'inset', '0');
        important(child, 'display', 'block');
        important(child, 'width', '100%');
        important(child, 'height', '100%');
        important(child, 'min-width', '100%');
        important(child, 'min-height', '100%');
        important(child, 'max-width', 'none');
        important(child, 'max-height', 'none');
        important(child, 'margin', '0');
        important(child, 'padding', '0');
        important(child, 'transform', 'none');
        important(child, 'object-fit', portrait ? 'cover' : 'contain');
        important(child, 'object-position', portrait ? '50% 20%' : '50% 50%');
      };

      applyChild();
      if (child.tagName === 'IMG' && !child.complete) child.addEventListener('load', applyChild, { once: true });
    });
  };

  const init = () => {
    document.querySelectorAll('[data-product-section]').forEach(root => {
      fitProductSection(root);
      const gallery = root.querySelector('[data-product-gallery]');
      if (!gallery || gallery.dataset.pneV5Observed === 'true') return;
      gallery.dataset.pneV5Observed = 'true';
      const observer = new MutationObserver(mutations => {
        if (mutations.some(m => m.type === 'attributes' && m.attributeName === 'class')) {
          requestAnimationFrame(() => fitProductSection(root));
        }
      });
      observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('load', init, { once: true });
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 80);
  }, { passive: true });

  if (mq.addEventListener) mq.addEventListener('change', init);
})();
